import { NgModule } from '@angular/core';

import { UiSwitchComponent } from './ui-switch.component';

@NgModule({
    declarations: [UiSwitchComponent],
    exports: [UiSwitchComponent]
})
export class UiSwitchModule {
}


// WEBPACK FOOTER //
// /Users/sheashay/Sites/ihsaa-ams-design/~/ngx-ui-switch/src/index.ts